module.exports = __webpack_public_path__ + "static/media/iconExcel.441a38eb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/iconExcel.svg
// module id = 161
// module chunks = 0